import type {
  DeliveryProposalOfferCargoStatus,
  OfferCargoProcessStatus,
} from "@/features/offer-cargo-process-status";
import {
  calculateDeliveryProposalContractStatus,
  calculateOfferCargoProcessReceptionStatus,
} from "@/features/offer-cargo-process-status/badge-status";
import { assertNever } from "@/shared/lib/assertNever";
import { OfferCargoStatusBadge } from "@/widgets/offer-cargo-status-badge";
import { Box, Stack, Typography } from "@mui/material";

export type StatusTitleProps = {
  title: string;
  viewer: "carrier" | "shipper";
} & (
  | {
      statusType: "offer_cargo_process_reception";
      offerCargoProcessStatus: OfferCargoProcessStatus;
    }
  | {
      statusType: "delivery_proposal_contract";
      deliveryProposalOfferCargoStatus: DeliveryProposalOfferCargoStatus;
    }
);

export const StatusTitle: React.FC<StatusTitleProps> = (props) => {
  const { title } = props;
  return (
    <Stack
      direction={"row"}
      spacing={1}
      alignItems="center"
      sx={{ minWidth: 256 }}
    >
      <Box width={4} borderRadius={999} sx={{ backgroundColor: "primary.400" }}>
        &nbsp;
      </Box>
      <Typography variant="body1" fontWeight={700} pl={1}>
        {title}：
      </Typography>
      {(() => {
        switch (props.statusType) {
          case "offer_cargo_process_reception":
            return (
              <OfferCargoStatusBadge
                statusType="offer_cargo_process_reception"
                status={calculateOfferCargoProcessReceptionStatus({
                  status: props.offerCargoProcessStatus,
                  viewer: props.viewer,
                })}
              />
            );
          case "delivery_proposal_contract":
            return (
              <OfferCargoStatusBadge
                statusType="delivery_proposal_contract"
                status={calculateDeliveryProposalContractStatus({
                  status: props.deliveryProposalOfferCargoStatus,
                  viewer: props.viewer,
                })}
              />
            );
          default:
            assertNever(props);
            throw new Error(`Unknown statusType: ${props}`);
        }
      })()}
    </Stack>
  );
};
